import {PUT} from 'utils/Http';

import {useSourceLoadData, useLoadCalendar} from 'hooks';

import AppointmentInfo, {AppointmentStatus} from 'types/Appointment';

import Button from 'components/Common/Button';
import {useSetNotification} from 'components/App/Notifications';

const {Confirmed, Cancelled} = AppointmentStatus;

type Props = {
  appointment: AppointmentInfo;
};

const CancelButton = ({appointment}: Props) => {
  const setNotification = useSetNotification();
  const loadCalendar = useLoadCalendar();
  const sourceLoadData = useSourceLoadData();
  const {id, status} = appointment;

  const onPress = async () => {
    await PUT<AppointmentInfo>(`appointments/${id}`, {
      status: Cancelled,
    });

    sourceLoadData();
    loadCalendar();

    setNotification({
      type: 'error',
      msg: 'appointments.cancel_success_msg',
      duration: 3000,
    });
  };

  return (
    <>
      {status === Confirmed && (
        <Button
          dialog={{
            title: 'appointments.cancel_dialog_title',
            subtitle: 'appointments.cancel_dialog_subtitle',
            label: 'appointments.cancel_dialog_button',
          }}
          className="btn gray"
          onPress={onPress}
          label="appointments.cancel_button"
        />
      )}
    </>
  );
};

export default CancelButton;
